// Login.js
import React, { useContext, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import axiosInstance from '../../axiosConfig';
import Notification from '../notification/Notification';
import '../../styles/Auth.css';
import { Circles } from 'react-loader-spinner';
import OAuth from './OAuth';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [notification, setNotification] = useState(null);
    const [loading, setLoading] = useState(false);
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!email || !password) {
            setNotification({ message: 'Please fill out all fields.', isError: true });
            return;
        }

        setLoading(true);

        try {
            const response = await axiosInstance.post('/api/auth/login', { email, password });

            const { accessToken, refreshToken, invitationLink, user } = response.data;
            login({ email: user.email, id: user.id, isAdmin: user.isAdmin }, accessToken, refreshToken, invitationLink);


            navigate("/");

        } catch (error) {
            setNotification({ message: 'Invalid user credentials. Please try again later', isError: true });
        } finally {
            setLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
        const passwordField = document.getElementById('password');
        if (passwordField.type === 'password') {
            passwordField.type = 'text';
        } else {
            passwordField.type = 'password';
        }
    };

    return (
        <div className="auth-container">
            <h2>Login</h2>
            <form onSubmit={handleLogin}>
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading}
                />

                <div className='show-hide-password'>

                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={loading}
                        id="password"
                    />

                    <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="show-password-button"
                    >
                        {showPassword ? 'Hide' : 'Show'}
                    </button>
                </div>


                <div className="notification-container">
                    <button type="submit" disabled={loading} className="auth-button">
                        {loading ? (
                            <Circles
                                height="20"
                                width="20"
                                color="#ffffff"
                                ariaLabel="circles-loading"
                                wrapperStyle={{ display: 'flex', justifyContent: 'center' }}
                                visible={true}
                            />
                        ) : (
                            'Login'
                        )}
                    </button>
                    {notification && (
                        <Notification
                            message={notification.message}
                            isError={notification.isError}
                            onClose={() => setNotification(null)}
                        />
                    )}
                </div>
            </form>
            <div className="auth-footer">

                <Link to="/signup" className="auth-link">
                    Sign up?
                </Link>
                <Link to="/request-password-reset" className="auth-link">
                    Forgot Password?
                </Link>
            </div>
            <OAuth />
        </div>
    );
};

export default Login;
